import { Stack } from "@mui/material";
import { DynamicEchartsChart } from "components/chart/DynamicChartMemoized";
import { useTranslation } from "react-i18next";

import type { EnergyAnalysisTrendChartType, EnergyAnalysisTrendSeries } from "../model/types";

import { buildTrendChartOption } from "../lib/buildTrendChartOption";
import { withEnergyAnalysisChartStyle } from "../lib/chartStyle";
import { TREND_CHART_TYPE_ICONS } from "../lib/chartTypeIcons";
import { ENERGY_ANALYSIS_TREND_CHART_TYPE } from "../model/constants";
import { EnergyAnalysisChartTypeMenu } from "./EnergyAnalysisChartTypeMenu";
import { EnergyAnalysisSectionTitle } from "./EnergyAnalysisSectionTitle";

const TREND_CHART_TYPES: EnergyAnalysisTrendChartType[] = [
  ENERGY_ANALYSIS_TREND_CHART_TYPE.stackedBar,
  ENERGY_ANALYSIS_TREND_CHART_TYPE.stackedPercent,
  ENERGY_ANALYSIS_TREND_CHART_TYPE.line,
];

type EnergyAnalysisTrendChartProps = {
  chartType: EnergyAnalysisTrendChartType;
  onChartTypeChange: (chartType: EnergyAnalysisTrendChartType) => void;
  series: EnergyAnalysisTrendSeries[];
  title: string;
  years: number[];
};

export const EnergyAnalysisTrendChart = ({
  chartType,
  onChartTypeChange,
  series,
  title,
  years,
}: EnergyAnalysisTrendChartProps) => {
  const { t } = useTranslation();
  return (
    <Stack className="w-full flex-col items-stretch gap-2">
      <Stack className="w-full items-center justify-between gap-2">
        <EnergyAnalysisSectionTitle iconName="Barchart" title={title} />
        <EnergyAnalysisChartTypeMenu
          onChange={onChartTypeChange}
          options={TREND_CHART_TYPES.map((type) => ({
            iconName: TREND_CHART_TYPE_ICONS[type],
            label: t(`BuildingProfile.energyAnalysis.chartTypes.${type}`),
            value: type,
          }))}
          value={chartType}
        />
      </Stack>
      <div className="h-[35rem] w-full [&_h3]:hidden">
        <DynamicEchartsChart
          className="h-full w-full"
          option={withEnergyAnalysisChartStyle(buildTrendChartOption(years, series, chartType))}
          secondYAxisRange={undefined}
          style={{ height: "100%" }}
          title={undefined}
          tooltip={undefined}
          xAxisRange={undefined}
          yAxisRange={undefined}
        />
      </div>
    </Stack>
  );
};
